import vtkCompositeCameraManipulator from './Manipulators/CompositeCameraManipulator.js';
import vtkCompositeGestureManipulator from './Manipulators/CompositeGestureManipulator.js';
import vtkCompositeKeyboardManipulator from './Manipulators/CompositeKeyboardManipulator.js';
import vtkCompositeMouseManipulator from './Manipulators/CompositeMouseManipulator.js';
import vtkCompositeVRManipulator from './Manipulators/CompositeVRManipulator.js';
import vtkGestureCameraManipulator from './Manipulators/GestureCameraManipulator.js';
import vtkKeyboardCameraManipulator from './Manipulators/KeyboardCameraManipulator.js';
import vtkMouseBoxSelectorManipulator from './Manipulators/MouseBoxSelectorManipulator.js';
import vtkMouseCameraAxisRotateManipulator from './Manipulators/MouseCameraAxisRotateManipulator.js';
import vtkMouseCameraSliceManipulator from './Manipulators/MouseCameraSliceManipulator.js';
import vtkMouseCameraUnicamManipulator from './Manipulators/MouseCameraUnicamManipulator.js';
import vtkMouseCameraUnicamRotateManipulator from './Manipulators/MouseCameraUnicamRotateManipulator.js';
import vtkMouseCameraTrackballFirstPersonManipulator from './Manipulators/MouseCameraTrackballFirstPersonManipulator.js';
import vtkMouseCameraTrackballMultiRotateManipulator from './Manipulators/MouseCameraTrackballMultiRotateManipulator.js';
import vtkMouseCameraTrackballPanManipulator from './Manipulators/MouseCameraTrackballPanManipulator.js';
import vtkMouseCameraTrackballRollManipulator from './Manipulators/MouseCameraTrackballRollManipulator.js';
import vtkMouseCameraTrackballRotateManipulator from './Manipulators/MouseCameraTrackballRotateManipulator.js';
import vtkMouseCameraTrackballZoomManipulator from './Manipulators/MouseCameraTrackballZoomManipulator.js';
import vtkMouseCameraTrackballZoomToMouseManipulator from './Manipulators/MouseCameraTrackballZoomToMouseManipulator.js';
import vtkMouseRangeManipulator from './Manipulators/MouseRangeManipulator.js';
import vtkVRButtonPanManipulator from './Manipulators/VRButtonPanManipulator.js';

var Manipulators = {
  vtkCompositeCameraManipulator: vtkCompositeCameraManipulator,
  vtkCompositeGestureManipulator: vtkCompositeGestureManipulator,
  vtkCompositeKeyboardManipulator: vtkCompositeKeyboardManipulator,
  vtkCompositeMouseManipulator: vtkCompositeMouseManipulator,
  vtkCompositeVRManipulator: vtkCompositeVRManipulator,
  vtkGestureCameraManipulator: vtkGestureCameraManipulator,
  vtkKeyboardCameraManipulator: vtkKeyboardCameraManipulator,
  vtkMouseBoxSelectorManipulator: vtkMouseBoxSelectorManipulator,
  vtkMouseCameraAxisRotateManipulator: vtkMouseCameraAxisRotateManipulator,
  vtkMouseCameraSliceManipulator: vtkMouseCameraSliceManipulator,
  vtkMouseCameraUnicamManipulator: vtkMouseCameraUnicamManipulator,
  vtkMouseCameraUnicamRotateManipulator: vtkMouseCameraUnicamRotateManipulator,
  vtkMouseCameraTrackballFirstPersonManipulator: vtkMouseCameraTrackballFirstPersonManipulator,
  vtkMouseCameraTrackballMultiRotateManipulator: vtkMouseCameraTrackballMultiRotateManipulator,
  vtkMouseCameraTrackballPanManipulator: vtkMouseCameraTrackballPanManipulator,
  vtkMouseCameraTrackballRollManipulator: vtkMouseCameraTrackballRollManipulator,
  vtkMouseCameraTrackballRotateManipulator: vtkMouseCameraTrackballRotateManipulator,
  vtkMouseCameraTrackballZoomManipulator: vtkMouseCameraTrackballZoomManipulator,
  vtkMouseCameraTrackballZoomToMouseManipulator: vtkMouseCameraTrackballZoomToMouseManipulator,
  vtkMouseRangeManipulator: vtkMouseRangeManipulator,
  vtkVRButtonPanManipulator: vtkVRButtonPanManipulator
};

export { Manipulators as default };
